import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  descriptionHtml:
    "Although human voice (dialogue, commentary, etc.) is a valid content that is typically included in the listening tests like presented previously, a dedicated set of methods has been defined over the years for speech quality assessment in real-time communication systems. In this section, we provide an example of a custom test methodology used to evaluate noise and echo reduction.</br></br>This time, listen to the recording of a conversation with signal processing turned on and try to compare it to the previous experience. How would you rate the quality in this case?",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0226/q2.html`,
            },
          },
        },
      },
    },
  },
};

export default principle;
